<template>
    <FormWrapper>
        <PageTitle title="Add/Update Page" slot="title" link="/helpContent/Add Page" />
        <br />
        <ValidationObserver ref="validator" >
            <FormRow>
                <div class="col-sm-3">
                    <InputText v-model="form.name" rules="required" label="Page Name"  />
                </div>
                <div class="col-sm-1">
                    <FormCheckbox v-model="form.isGrid">IsGrid</FormCheckbox>
                </div>
                <div class="col-sm-1">
                    <FormCheckbox v-model="form.isDetail">IsDetail</FormCheckbox>
                </div>
            </FormRow>
            <br>
        </ValidationObserver>
        <FormRow>
            <div class="col-sm-6" >
                <ButtonGroup>
                    <FormButton type="info" @click="()=>{$router.go(-1)}">Back</FormButton>
                    <FormButton type="success" @click="sendData()">Save</FormButton>
                </ButtonGroup>
            </div>
        </FormRow>
        <Popup title="Success" type="success" :value="showMessage.isVisible"  @close="() => (showMessage.isVisible = false)" :closable="true">
            {{ showMessage.message }}
            <div slot="footer">
                <FormButton @click="()=>{$router.go(-1)}">Ok</FormButton>
            </div>
        </Popup>
    </FormWrapper>
</template> 

<script>
    import FormWrapper from 'Components/form/FormWrapper';
    import PageTitle from 'Components/layout/PageTitle';
    import loadingMixin from 'Mixins/loadingMixin';
    import {addUpdatePage, getPageList} from '../api';
    import { ValidationObserver } from 'vee-validate';
    export default {
        name: "AddUpdate",
        mixins: [loadingMixin],
        components: {
            FormWrapper,
            PageTitle,
            ValidationObserver
        },
        data() {
            return {
                showMessage:{
                    isVisible: false,
                    message: ''
                },
                form:{
                    name:'',
                    isGrid:0,
                    isDetail:0
                },
            }
        },
        computed: {
          userData() {
              return this.$store.state.user.user
            }
        },
        watch: {
        },
        created() {
            this.getDataByFilter()
        },
        methods: {
            getDataByFilter() {
                if(this.$route.params.id){
                    setTimeout(() => {
                        this.showLoader();
                        const filters = {};
                        filters.pageId = atob(this.$route.params.id);
                        const data = {
                            filterjson: {
                                filter: [filters]
                            }
                        };
                        getPageList(data)
                            .then(this.handleResponse)
                            .catch(this.handleError)
                    },
                    50
                    )
                }
            },
            sendData(){
                this.$refs.validator.validate().then(result=>{
                    if(result){
                        this.showMessage.isVisible=false;
                        const data={
                            pageId: this.$route.params.id?atob(this.$route.params.id):0,
                            pageName: this.form.name,
                            isGrid: this.form.isGrid,
                            isDetail: this.form.isDetail
                        };
                        addUpdatePage(data).then((res)=>{
                            this.form = {};
                            this.showMessage.isVisible=true;
                            this.showMessage.message=res.data[0].message;
                        })
                    }
                })
            },
            handleResponse(response) {
                this.hideLoader();
                this.form.name = response.data[0].PageName;
                this.form.isGrid = response.data[0].IsGridPage?true:false;
                this.form.isDetail = response.data[0].IsDetailPage?true:false;
            },
        }
    }
</script>
<style lang="scss">
    body{
        padding-right: 0px !important;
        overflow: auto !important;
    }
</style>